const s = "_spinner_19olw_9", _ = "_rotate_19olw_1", o = "_dash_19olw_1", t = "_sm_19olw_36", n = "_md_19olw_37", l = "_lg_19olw_49", e = {
  spinner: s,
  rotate: _,
  dash: o,
  sm: t,
  md: n,
  lg: l
};
export {
  o as dash,
  e as default,
  l as lg,
  n as md,
  _ as rotate,
  t as sm,
  s as spinner
};
//# sourceMappingURL=spinner.module.less.js.map
